import {
  Routes,
  Route,
  useLocation,
  Link,
  Navigate,
  Outlet,
  useNavigate,
} from "react-router-dom";

import "./App.css";

import { useAuth } from "./context/AuthContext";
import { useState } from "react";

// ======================================================
// PAGES
// ======================================================

import ClientsPage from "./pages/clients/ClientsPage";
import TechnicienPage from "./pages/technicien/TechnicienPage";
import EntretienPage from "./pages/entretien/EntretienPage";
import UsersPage from "./pages/utilisateurs/UsersPage";
import RendezVousPage from "./pages/RendezVous/RendezVousPage";

import Dashboard from "./pages/dashboard/Dashboard";

import Login from "./pages/Login";

import ProtectedRoute from "./components/ProtectedRoute";

import DashboardTechnicien from "./pages/dashboardTechnicien/DashboardTechnicien";
import RendezVousTechnicien from "./pages/dashboardTechnicien/RendezVousTechnicien";

import Unauthorized from "./pages/Unauthorized";

import Sidebar from "./components/Sidebar";

import ModePaiementPage from "./pages/modePaiement/ModePaiementPage";
import PaiementsPage from "./pages/paiements/PaiementsPage";
import FinancePage from "./pages/finance/FinancePage";


// ======================================================
// APP
// ======================================================

function App() {

  const location = useLocation();

  const { logout } = useAuth();

  const navigate = useNavigate();

  const [openProfile, setOpenProfile] = useState(false);


  // ======================================================
  // UTILISATEUR
  // ======================================================

  const token = localStorage.getItem("token");

  let user = null;

  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    user = null;
  }


  // ======================================================
  // PAGE LOGIN
  // ======================================================

  const isLoginPage = location.pathname === "/login";


  // ======================================================
  // LOGOUT
  // ======================================================

  const handleLogout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    logout();

    setOpenProfile(false);

    navigate("/login");
  };


  // ======================================================
  // LAYOUT TECHNICIEN
  // ======================================================

  const TechnicienLayout = () => {
    return <Outlet />;
  };


  // ======================================================
  // RENDER
  // ======================================================

  return (
    <div className="app-layout">


      {/* ==================================================
          SIDEBAR
      ================================================== */}

      {!isLoginPage && <Sidebar />}


      {/* ==================================================
          HEADER
      ================================================== */}

      {!isLoginPage && (
        <header className="app-header">

          {/* Logo */}
          <div className="logo">
            Climatisation LS
          </div>


          {/* Header actions */}
          <div className="header-actions">

            {user ? (

              <div className="profile-menu">

                {/* Profile */}
                <div
                  className="profile-trigger"
                  onClick={() =>
                    setOpenProfile(!openProfile)
                  }
                >

                  👤 {user.nom}

                  <span
                    className={`arrow ${
                      openProfile ? "up" : ""
                    }`}
                  >
                    ▼
                  </span>

                </div>


                {/* Dropdown */}
                {openProfile && (

                  <div className="profile-dropdown">

                    {/* Informations */}
                    <div className="profile-info">

                      <strong>
                        {user.nom}
                      </strong>

                      <span
                        className={`role-badge ${
                          user.role
                            ? user.role.toLowerCase()
                            : ""
                        }`}
                      >
                        {user.role === "ADMIN"
                          ? "Admin"
                          : "Technicien"}
                      </span>

                    </div>


                    {/* Rendez-vous technicien */}
                    {user.role === "TECHNICIEN" && (

                      <Link
                        to="/technicien/mes-rendez-vous"
                        className="dropdown-item"
                        onClick={() =>
                          setOpenProfile(false)
                        }
                      >
                        📅 Mes rendez-vous
                      </Link>

                    )}


                    {/* Logout */}
                    <button
                      type="button"
                      onClick={handleLogout}
                      className="dropdown-item logout"
                    >
                      🚪 Déconnexion
                    </button>

                  </div>

                )}

              </div>

            ) : (

              <Link
                to="/login"
                className="btn-login"
              >
                Login
              </Link>

            )}

          </div>

        </header>
      )}


      {/* ==================================================
          MAIN CONTENT
      ================================================== */}

      <main
        className={`content ${
          isLoginPage ? "login-content" : ""
        }`}
      >

        <Routes>

          {/* ==================================================
              LOGIN
          ================================================== */}

          <Route
            path="/"
            element={
              <Navigate
                to="/login"
                replace
              />
            }
          />

          <Route
            path="/login"
            element={<Login />}
          />

          <Route
            path="/unauthorized"
            element={<Unauthorized />}
          />


          {/* ==================================================
              ADMIN
          ================================================== */}

          <Route
            path="/admin"
            element={
              <ProtectedRoute role="ADMIN">
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/clients"
            element={
              <ProtectedRoute role="ADMIN">
                <ClientsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/techniciens"
            element={
              <ProtectedRoute role="ADMIN">
                <TechnicienPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/types-entretien"
            element={
              <ProtectedRoute role="ADMIN">
                <EntretienPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/utilisateurs"
            element={
              <ProtectedRoute role="ADMIN">
                <UsersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/rendez-vous"
            element={
              <ProtectedRoute role="ADMIN">
                <RendezVousPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/modes"
            element={
              <ProtectedRoute role="ADMIN">
                <ModePaiementPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/paiements"
            element={
              <ProtectedRoute role="ADMIN">
                <PaiementsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/finance"
            element={
              <ProtectedRoute role="ADMIN">
                <FinancePage />
              </ProtectedRoute>
            }
          />


          {/* ==================================================
              TECHNICIEN
          ================================================== */}

          <Route
            path="/technicien"
            element={
              <ProtectedRoute role="TECHNICIEN">
                <TechnicienLayout />
              </ProtectedRoute>
            }
          >

            <Route
              index
              element={<DashboardTechnicien />}
            />

            <Route
              path="mes-rendez-vous"
              element={<RendezVousTechnicien />}
            />

          </Route>

        </Routes>

      </main>

    </div>
  );
}

export default App;